import React, { useState } from 'react';
import { PLANS } from '../../../config/settings';
import StepIndicator from './StepIndicator';
import PlanSelection from './PlanSelection';
import DiscountApplication from './DiscountApplication';
import PaymentStep from './PaymentStep';

const MultiStepSubscription = () => {
  const [currentStep, setCurrentStep] = useState(1);
  const [subscriptionData, setSubscriptionData] = useState({
    selectedPlan: PLANS[0],
    appliedDiscount: null,
  });

  const steps = [
    { id: 1, title: 'Piano', description: 'Scegli il tuo piano' },
    { id: 2, title: 'Sconto', description: 'Applica codice sconto' },
    { id: 3, title: 'Pagamento', description: 'Completa il pagamento' },
  ];

  const handleNext = () => {
    if (currentStep < steps.length) {
      setCurrentStep(currentStep + 1);
    }
  };

  const handlePrevious = () => {
    if (currentStep > 1) {
      setCurrentStep(currentStep - 1);
    }
  };

  const handleStepClick = (stepId) => {
    // Allow navigation to previous steps or current step
    if (stepId <= currentStep) {
      setCurrentStep(stepId);
    }
  };

  const updateSubscriptionData = (updates) => {
    setSubscriptionData(prev => ({
      ...prev,
      ...updates
    }));
  };

  const renderCurrentStep = () => {
    switch (currentStep) {
      case 1:
        return (
          <PlanSelection
            selectedPlan={subscriptionData.selectedPlan}
            onPlanSelect={(plan) => updateSubscriptionData({ selectedPlan: plan })}
            onNext={handleNext}
          />
        );
      case 2:
        return (
          <DiscountApplication
            plan={subscriptionData.selectedPlan}
            appliedDiscount={subscriptionData.appliedDiscount}
            onDiscountApplied={(discount) => updateSubscriptionData({ appliedDiscount: discount })}
            onDiscountRemoved={() => updateSubscriptionData({ appliedDiscount: null })}
            onNext={handleNext}
            onPrevious={handlePrevious}
          />
        );
      case 3:
        return (
          <PaymentStep
            plan={subscriptionData.selectedPlan}
            appliedDiscount={subscriptionData.appliedDiscount}
            onPrevious={handlePrevious}
          />
        );
      default:
        return null;
    }
  };

  return (
    <div className="container">
      <div className="row justify-content-center">
        <div className="col-12">
          <h1 className="text-center mb-4">Scegli il tuo abbonamento</h1>
          
          <StepIndicator
            steps={steps}
            currentStep={currentStep}
            onStepClick={handleStepClick}
          />
          
          <div className="twitter-bs-wizard-tab-content">
            {renderCurrentStep()}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MultiStepSubscription;